import { useState, useEffect } from 'react';
import { GLTFExporter } from 'three/addons/exporters/GLTFExporter.js';
import { USDZExporter } from 'three/addons/exporters/USDZExporter.js';
import { useGLTF } from '@react-three/drei'
import * as THREE from 'three';
import { StyledFigurePreview } from './FigurePreview.styled';
import { ModelLoading } from '../';

// Yarik: This conversion is necessary because model-viewer's parser can't
// parse VRMs. Also the GLB for <model-viewer> must have only MeshStandardMaterials.
const convertToGlb = async (model, onComplete) => {
  model.traverse((child) => {
    if (!child.isMesh) return;
    let prevMaterial = child.material;
    child.material = new THREE.MeshStandardMaterial();
    THREE.MeshBasicMaterial.prototype.copy.call(child.material, prevMaterial);
  });

  const exporter = new USDZExporter();
  const arraybuffer = await exporter.parse(model);
  const blob = new Blob([arraybuffer], { type: 'model/vnd.usdz+zip' });
  onComplete(URL.createObjectURL(blob));
};

// This one converts T-pose into standing still
// For some reason it is applied fine in model-viewer
// but iOS QiuckLook AR drops these rotations (unlike
// the main model rotation)
const standStill = (scene) => {
  scene.getObjectByName('RightArm').rotation.z = -1.2;
  scene.getObjectByName('RightForeArm').rotation.z = -0.5;
  scene.getObjectByName('LeftArm').rotation.z = 1.2;
  scene.getObjectByName('LeftForeArm').rotation.z = 0.5;
};

export default function FigurePreview({ glbPath }) {
  const { scene } = useGLTF(glbPath);
  const [glbLink, setGlbLink] = useState(null);

  useEffect(() => {
    if (scene) {
      convertToGlb(scene, (url) => setGlbLink(url));
    }
  }, [scene]);

  return (
    <StyledFigurePreview>
      {glbLink &&
        <model-viewer alt="Broadsider" camera-orbit='180deg 75deg 100%' src={glbPath} ios-src={glbLink} ar shadow-intensity="1" camera-controls touch-action="pan-y">
          <button slot="ar-button">Tap to View in AR</button>
        </model-viewer>}
      {!glbLink && <ModelLoading />}
    </StyledFigurePreview>
  )
}
